'use client';

import React, { useState, useEffect } from 'react';
import TopLeftOrgSwitch from './TopLeftOrgSwitch';
import Header from './Header';
import HeroSection from './HeroSection';
import WebGLBackground from './WebGLBackground';
import EcosystemShowcase from './EcosystemShowcase';
import CommunitySection from './CommunitySection';
import FooterSection from './FooterSection';
import OrbitalProjectModal from '@/components/common/OrbitalProjectModal';
import AnchorNavigation from '@/components/common/AnchorNavigation';
import ProgressIndicator from '@/components/common/ProgressIndicator';

interface ProjectData {
  id: string;
  name: string;
  symbol: string;
  logo: string;
  description: string;
  category: string;
  metrics: {
    tvl: string;
    marketCap: string;
    holders: string;
    volume24h: string;
  };
  tokenomics: {
    totalSupply: string;
    circulatingSupply: string;
    tokenPrice: string;
    fdv: string;
  };
  team: Array<{
    name: string;
    role: string;
    avatar: string;
    credentials: string;
  }>;
  website: string;
  whitepaper: string;
  auditReport: string;
  connections: string[];
}

export default function LandingPageInteractive() {
  const [isHydrated, setIsHydrated] = useState(false);
  const [selectedProject, setSelectedProject] = useState<ProjectData | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleExploreClick = () => {
    document.getElementById('ecosystem-section')
      ?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleInvestmentClick = () => {
    document.getElementById('investment-section')
      ?.scrollIntoView({ behavior: 'smooth' });
  };

const handleCloseModal = () => {
  setIsModalOpen(false);
  setTimeout(() => {
    setSelectedProject(null);
  }, 300);
};

  const handleProjectClick = (project: any) => {
    setSelectedProject({
      ...project,
      tokenomics: {
        totalSupply: '1,000,000,000',
        circulatingSupply: '450,000,000',
        tokenPrice: '$2.45',
        fdv: '$2.45B',
      },
      team: [
        {
          name: 'Alex Johnson',
          role: 'Founder & CEO',
          avatar: 'https://img.rocket.new/generatedImages/rocket_gen_img_18276e8bd-1765872905794.png',
          credentials: 'Former VP at Coinbase, 10+ years blockchain experience',
        },
        {
          name: 'Sarah Chen',
          role: 'CTO',
          avatar: 'https://img.rocket.new/generatedImages/rocket_gen_img_12f2fa675-1763295678226.png',
          credentials: 'Ex-Google engineer, Smart contract security expert',
        },
      ],
    });
    setIsModalOpen(true);
  };

  if (!isHydrated) {
    return (
      <div data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:101:6" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="101" data-component-end-line="108" data-component-file="LandingPageInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20bg-background%20flex%20items-center%20justify-center%22%7D" className="min-h-screen bg-background flex items-center justify-center">
        <div data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:102:8" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="102" data-component-end-line="107" data-component-file="LandingPageInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%22%7D" className="text-center">
          <div data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:103:10" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="103" data-component-end-line="103" data-component-file="LandingPageInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-20%20h-20%20mx-auto%20mb-8%20rounded-full%20bg-accent%20animate-pulse%22%7D" className="w-20 h-20 mx-auto mb-8 rounded-full bg-accent animate-pulse" />
          <p data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:104:10" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="104" data-component-end-line="106" data-component-file="LandingPageInteractive.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-orbitron%20font-bold%20text-2xl%20text-text-primary%22%2C%22textContent%22%3A%22Loading%20MGO%20Orbital...%22%7D" className="font-orbitron font-bold text-2xl text-text-primary">
            Loading MGO Orbital...
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
  <WebGLBackground data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:114:2" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="114" data-component-end-line="114" data-component-file="LandingPageInteractive.tsx" data-component-name="WebGLBackground" data-component-content="%7B%22elementName%22%3A%22WebGLBackground%22%7D" />

  <main data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:116:2" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="116" data-component-end-line="131" data-component-file="LandingPageInteractive.tsx" data-component-name="main" data-component-content="%7B%22elementName%22%3A%22main%22%2C%22className%22%3A%22relative%20z-10%22%7D" className="relative z-10">
    <TopLeftOrgSwitch data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:117:4" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="117" data-component-end-line="117" data-component-file="LandingPageInteractive.tsx" data-component-name="TopLeftOrgSwitch" data-component-content="%7B%22elementName%22%3A%22TopLeftOrgSwitch%22%7D" />
    <Header data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:118:4" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="118" data-component-end-line="118" data-component-file="LandingPageInteractive.tsx" data-component-name="Header" data-component-content="%7B%22elementName%22%3A%22Header%22%7D" />

    <HeroSection data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:120:4" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="120" data-component-end-line="123" data-component-file="LandingPageInteractive.tsx" data-component-name="HeroSection" data-component-content="%7B%22elementName%22%3A%22HeroSection%22%7D"
      onExploreClick={handleExploreClick}
      onInvestmentClick={handleInvestmentClick}
    />

    <EcosystemShowcase data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:125:4" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="125" data-component-end-line="125" data-component-file="LandingPageInteractive.tsx" data-component-name="EcosystemShowcase" data-component-content="%7B%22elementName%22%3A%22EcosystemShowcase%22%7D" onProjectClick={handleProjectClick} />
    <CommunitySection data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:126:4" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="126" data-component-end-line="126" data-component-file="LandingPageInteractive.tsx" data-component-name="CommunitySection" data-component-content="%7B%22elementName%22%3A%22CommunitySection%22%7D" />
    <FooterSection data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:127:4" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="127" data-component-end-line="127" data-component-file="LandingPageInteractive.tsx" data-component-name="FooterSection" data-component-content="%7B%22elementName%22%3A%22FooterSection%22%7D" />

    <AnchorNavigation data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:129:4" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="129" data-component-end-line="129" data-component-file="LandingPageInteractive.tsx" data-component-name="AnchorNavigation" data-component-content="%7B%22elementName%22%3A%22AnchorNavigation%22%7D" />
    <ProgressIndicator data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:130:4" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="130" data-component-end-line="130" data-component-file="LandingPageInteractive.tsx" data-component-name="ProgressIndicator" data-component-content="%7B%22elementName%22%3A%22ProgressIndicator%22%7D" />
  </main>

  <OrbitalProjectModal data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:133:2" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="133" data-component-end-line="137" data-component-file="LandingPageInteractive.tsx" data-component-name="OrbitalProjectModal" data-component-content="%7B%22elementName%22%3A%22OrbitalProjectModal%22%7D"
    isOpen={isModalOpen}
    onClose={handleCloseModal}
    project={selectedProject}
  />
</>
  );
}
